import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

import { StopsListDataIdentifierCommonForm } from './StopsListDataIdentifierCommonForm';

export class VerticalStopsListDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let stopsListConfiguration = {
            showOnlyInSpineStops: false,
            hideNonInSpineStops: false,
            hidePreviousStops: false,
            hideZoneLimitStops: false,
            hideStopsWithMapPoint: false,
            shrinkText: false,
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: "",
            durationBackgroundBuilderComponent: 0,
            zonesBackgroundBuilderComponent: 0,
        };

        if (null !== this.props.selectedData && undefined !== this.props.selectedData) {
            stopsListConfiguration = Object.assign(stopsListConfiguration, JSON.parse(this.props.selectedData));
        }

        this.state = {
            form: {
                showOnlyInSpineStops: stopsListConfiguration.showOnlyInSpineStops,
                hideNonInSpineStops: stopsListConfiguration.hideNonInSpineStops,
                hidePreviousStops: stopsListConfiguration.hidePreviousStops,
                hideZoneLimitStops: stopsListConfiguration.hideZoneLimitStops,
                hideStopsWithMapPoint: stopsListConfiguration.hideStopsWithMapPoint,
                shrinkText: stopsListConfiguration.shrinkText,
                showStopCode: stopsListConfiguration.showStopCode,
                stopCodePrecendentText: stopsListConfiguration.stopCodePrecendentText,
                stopCodeSubsequentText: stopsListConfiguration.stopCodeSubsequentText,
                durationBackgroundBuilderComponent: stopsListConfiguration.durationBackgroundBuilderComponent,
                zonesBackgroundBuilderComponent: stopsListConfiguration.zonesBackgroundBuilderComponent,
            }
        };
    }

    // -----------------------

    onSelectData() {
        const { form } = this.state;

        const stopsListConfiguration = {
            showOnlyInSpineStops: form.showOnlyInSpineStops,
            hideNonInSpineStops: form.hideNonInSpineStops,
            hidePreviousStops: form.hidePreviousStops,
            hideZoneLimitStops: form.hideZoneLimitStops,
            hideStopsWithMapPoint: form.hideStopsWithMapPoint,
            shrinkText: form.shrinkText,
            showStopCode: form.showStopCode,
            stopCodePrecendentText: form.stopCodePrecendentText,
            stopCodeSubsequentText: form.stopCodeSubsequentText,
            durationBackgroundBuilderComponent: form.durationBackgroundBuilderComponent,
            zonesBackgroundBuilderComponent: form.zonesBackgroundBuilderComponent,
        };
        this.props.onSelectData(JSON.stringify(stopsListConfiguration), true);
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeSelectValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    // -----------------------

    render() {
        const { form } = this.state;

        return (
            <Form>
                <StopsListDataIdentifierCommonForm 
                    form={form}
                    onChangeValue={(a, b) => this.onChangeValue(a, b)}
                    onChangeCheckboxValue={(a) => this.onChangeCheckboxValue(a)}
                    onChangeSelectValue={(a, b) => this.onChangeSelectValue(a, b)}
                    onCancel={this.props.onCancel}
                    onSelectData={() => this.onSelectData()} />
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/VerticalStopsListDataIdentifier.js